import { computed, ComputedRef } from 'vue';
import { shouldHideSections, type BookingSection } from '@/config/liheVisibility';



export function useSectionVisibilty(liheId: number, liheName?: string, packageCode?: string): {
    showStationHeader: ComputedRef<boolean>,
    showBookingDate: ComputedRef<boolean>,
    showPrestationInfo: ComputedRef<boolean>,
    showPanelAction: ComputedRef<boolean>,
    showAccommodationOption: ComputedRef<boolean>,
    showPackageSection: ComputedRef<boolean>
} {
    const isSectionVisible = (section: BookingSection) =>
        !shouldHideSections(liheId, liheName, packageCode);

  return {
    showStationHeader: computed<boolean>(() => isSectionVisible('stationHeader')),
    showBookingDate: computed<boolean>(() => isSectionVisible('stationHeader')),
    showPrestationInfo: computed<boolean>(() => isSectionVisible('stationHeader')),
    showPanelAction: computed<boolean>(() => isSectionVisible('panelAction')),
    showAccommodationOption: computed<boolean>(() => isSectionVisible('accommodationOption')),
    showPackageSection: computed<boolean>(() => isSectionVisible('packageSection')),
  };
}